import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import * as dayjs from 'dayjs';

export const DATE_FORMAT = 'DD/MM/YYYY';
export const DATE_TIME_FORMAT = 'DD/MM/YYYY HH:mm';

export const ngbDateToDayjs = (ngbd: NgbDateStruct): any => {
  let result = undefined;
  if (ngbd) {
    result = dayjs(new Date(ngbd.year, ngbd.month - 1, ngbd.day, 11));
  }
  return result;
};

export enum DisplayMode {
  Consult = 0,
  Edit = 1,
  Action = 2,
}
